/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { KEY_ENTER } from '@gh/core-ui';
import { stopEvent } from '@gh/core-util';

import { noop } from 'lodash';

@Component({
  selector: 'gh-text-list-filter',
  template: require('./text-list-filter.component.html'),
  styles: [require('./text-list-filter.component.scss')],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: TextListFilterComponent, multi: true }],
})
export class TextListFilterComponent implements ControlValueAccessor, AfterViewInit {
  textControl = new FormControl('');
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  // tslint:disable-next-line:no-input-prefix
  @Input() isTriggerOnChange: boolean = false;
  @Input() placeholder: string = 'lbl_search';
  @Input() focusOnInit: boolean;
  @Input() hideLoop: boolean;

  @Output() trigger = new EventEmitter<string>();

  @Input()
  set value(text: string) {
    this.textControl.setValue(text);
  }

  private _onChange = noop;

  ngAfterViewInit(): void {
    if (this.focusOnInit) {
      setTimeout(() => { this.searchInput?.nativeElement?.focus(); });
    }
  }

  onSearch(): void {
    this.search();
  }

  onClear(): void {
    this._onChange(void 0);
    this.search();
  }

  @HostListener('keydown', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    if (event.keyCode === KEY_ENTER) {
      stopEvent(event);

      this.onSearch();
    }
  }

  onInput(value: string): void {
    value = value.trim();
    this._onChange(value.length === 0 ? void 0 : value);
    if (this.isTriggerOnChange) {
      this.trigger.emit(this.textControl.value);
    }
  }

  writeValue(obj: any): void {
    this.textControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    // nothing to do
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled !== this.textControl.disabled) {
      return;
    }

    if (isDisabled) {
      this.textControl.disable();
    } else {
      this.textControl.enable();
    }
  }

  private search(): void {
    this.trigger.emit(this.textControl.value);
  }
}
